import { Skelton } from 'library/skelton';

const ProgressGPTBarLoading = () => {
    return (
        <div>
            <div className="text-xs mt-4">
                <Skelton width="20%" />
            </div>
            {Array.from(Array(6).keys()).map((r, i) => (
                <div key={i} className="text-sm mt-3">
                    <Skelton width="100%" />
                </div>
            ))}
        </div>
    );
};

export default ProgressGPTBarLoading;
